import {
  PATIENT_PROFILE_REQUEST,
  PATIENT_PROFILE_SUCCESS,
  PATIENT_PROFILE_FAIL,
} from "../constants/patientConstant";

export const patientProfileReducer = (state = { patient: {} }, action) => {
  switch (action.type) {
    case PATIENT_PROFILE_REQUEST:
      return {
        ...state,
      };

    case PATIENT_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        patient: action.payload,
      };

    case PATIENT_PROFILE_FAIL:
      return {
        loading: false,
        patient: null,
        error: action.payload,
      };
    default:
      return state;
  }
};
